<div [formGroup]="form">
    <input [attr.type]="field.type"[dropSpecialCharacters]="false" [mask]="(field.name === 'phoneNumber' || field.name ==='phone_Number') ? '(000) 000-0000' : ''" autocomplete="off" [id]="field.name" [name]="field.name"
        [maxlength]="field.maxLength" [formControlName]="field.name" class="form-control input-font" (input)="restrictAlphabets($event)" 
        [placeholder]="field.placeholder">
   
        @if((form.get(field.name)?.touched ||form.get(field.name)?.dirty) && form.get(field.name)?.invalid) {
            <small class="invalid-feedback">
                @if(form.get(field.name)?.hasError('required')) {
                    {{field.label}} is required
                } @else if(form.get(field.name)?.hasError('pattern')) {
                    Please enter a valid {{ field.label }}
                }
            </small>
        }
</div>